/* eslint semi:0 */
import { BaseStore } from 'stores/baseStore'
import dialog from 'providers/dialogProvider'
import { mithrilHelpers, } from 'utils/mithril'
import modalActions from 'actions/modalActions'
import pageDataObject from 'application/pageDataObject'
import userActions from 'actions/userToolbarActions'
import { localizedPath, } from 'providers/i18nProvider/i18nProvider'
import { areComponentsIdentical } from 'utils/component'
import signupModalComponent from 'components/signupModalComponent'

const SIGNUP_PATH = pageDataObject.get('config.signup_path')

class SignupModalStore extends BaseStore {

  routeAction(action) {
    switch (action.type) {
      case modalActions.TYPES.CLOSE:
        return this.onModalDirtyClose()
    }
  }

  get languages() { return this.options.modalData.languages }

  get leagues() { return this.options.modalData.leagues }

  get localeLeague() { return this.options.modalData.locale_league }

  get localeLeagueName() { return this.options.modalData.locale_league_name }

  get teams() { return this.options.modalData.teams }

  get termsUrl() { return this.options.modalData.terms_url }

  get authId() { return this.options.authId }

  set isLoading(flag) {
    this.vm.isLoading(flag)
    this.vm.onChange()
  }

  set serverValidationErrors(errors) { this.vm.serverValidationErrors(errors) }

  onModalDirtyClose() {
    if (areComponentsIdentical(dialog.modal.currentComponent, signupModalComponent)) {
      return setImmediate(userActions.autnenticationFailed)
    }
  }

  submit(data) {
    let url = localizedPath(SIGNUP_PATH)

    mithrilHelpers.safeRequest({
      method: 'POST',
      data,
      url,
      serialize: function(serializeData) {
        return serializeData
      },
    }).then(
      this.onSubmitResponse.bind(this),
      this.onSubmitFailed.bind(this)
    )
    this.isLoading = true
  }

  onSubmitResponse(response) {
    this.isLoading = false
    response.errors ? this.onSubmitFailed(response) : this.onSubmitSucceed(response)
  }

  onSubmitSucceed(response) {
    response.existing = true
    userActions.authenticated(response)
    dialog.modal.close()
  }

  onSubmitFailed(response) {
    this.isLoading = false
    this.vm.refreshCaptcha()
    this.serverValidationErrors = response.errors
  }

}

export default SignupModalStore



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/SignupModalStore.js